import { useMemo, memo } from "react";
import Chart from "react-apexcharts";
import "./chart.css";

function ChartDonut({
  data,
  categoryKey,
  valueKey,
  percentageKey,
  showPercentage = true,
}) {
  const labels = useMemo(
    () => (data ?? []).map((item) => `Forma ${item[categoryKey]}`),
    [data, categoryKey]
  );

  const series = useMemo(
    () => showPercentage
      ? (data ?? []).map((item) => item[percentageKey])
      : (data ?? []).map((item) => item[valueKey]),
    [data, showPercentage, percentageKey, valueKey]
  );

  const options = useMemo(
    () => ({
      chart: { type: "donut" },
      labels,
      dataLabels: {
        enabled: true,
        formatter: (val) => showPercentage ? `${val.toFixed(1)}%` : val,
      },
      tooltip: {
        y: { formatter: (val) => showPercentage ? `${val.toFixed(2)}%` : val },
      },
      legend: {
        position: "bottom",
        labels: { colors: "var(--text-50)" },
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: { width: 200 },
          legend: { position: "bottom" },
        },
      }],
    }),
    [labels, showPercentage]
  );

  return (
    <Chart options={options} series={series} type="donut" height="100%" width="100%" />
  );
}

export default memo(ChartDonut);
